import { DeleteOutlined, SettingOutlined } from "@ant-design/icons";
import { Button, Col, InputNumber, Row, Select } from "antd";
import { DrawerLink } from "components/UI/DrawerLink";
import { FC } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { FormItem } from "react-hook-form-antd";
import { ConnectionSequenceStepConnectionType } from "types/enums";
import { DrawerId } from "types/models";

import { FormData } from "../formSchema";

const { Option } = Select;

interface FurtherStepSectionProps {
    name: number; // index of this field in the stepConnection array
    methodIndex: number; // index of the method in methods array
    responseHandlerIndex: number; // index of the response handler in responseHandlers array
    handleRemove: () => void;
}

export const FurtherStepSection: FC<FurtherStepSectionProps> = ({
    name,
    methodIndex,
    responseHandlerIndex,
    handleRemove,
}) => {
    const { control, watch } = useFormContext<FormData>();
    const reqSetting = DrawerId.ResponseFurtherStepSetting;

    const stepPath =
        `methods.${methodIndex}.requestConfig.responseHandlers.${responseHandlerIndex}.stepConnection.${name}` as const;

    const type = useWatch({
        control,
        name: `${stepPath}.type` as const,
    }) as ConnectionSequenceStepConnectionType | undefined;

    const methods = watch("methods");

    let inputsByType;
    switch (type) {
        case ConnectionSequenceStepConnectionType.Wait:
            inputsByType = (
                <Col span={6}>
                    <FormItem control={control} name={`${stepPath}.wait_ms`} label="Wait (ms)" labelCol={{ span: 24 }}>
                        <InputNumber min={0} placeholder="Enter wait time in ms" style={{ width: "100%" }} />
                    </FormItem>
                </Col>
            );
            break;
        case ConnectionSequenceStepConnectionType.GoToStep:
            inputsByType = (
                <Col span={6}>
                    <FormItem
                        control={control}
                        name={`${stepPath}.connection_sequence_step_target_id`}
                        label="Akce"
                        labelCol={{ span: 24 }}
                    >
                        <Select placeholder="Select a source">
                            {methods?.map(({ name: methodName, id }) => (
                                <Option value={id} key={id}>
                                    {methodName}
                                </Option>
                            ))}
                        </Select>
                    </FormItem>
                </Col>
            );
            break;
        case ConnectionSequenceStepConnectionType.DelayedStep:
            inputsByType = (
                <>
                    <Col span={6}>
                        <FormItem
                            control={control}
                            name={`${stepPath}.wait_ms`}
                            label="Wait (ms)"
                            labelCol={{ span: 24 }}
                        >
                            <InputNumber min={0} placeholder="Enter wait time in ms" style={{ width: "100%" }} />
                        </FormItem>
                    </Col>
                    <Col span={6}>
                        <FormItem
                            control={control}
                            name={`${stepPath}.connection_sequence_step_target_id`}
                            label="Akce"
                            labelCol={{ span: 24 }}
                        >
                            <Select placeholder="Select a source">
                                {methods?.map(({ name: methodName, id }) => (
                                    <Option value={id} key={id}>
                                        {methodName}
                                    </Option>
                                ))}
                            </Select>
                        </FormItem>
                    </Col>
                </>
            );
            break;
    }

    return (
        <Row gutter={16} align="middle">
            <Col span={6}>
                <FormItem control={control} name={`${stepPath}.type`} label="Typ" labelCol={{ span: 24 }}>
                    <Select placeholder="Select a type">
                        {Object.values(ConnectionSequenceStepConnectionType).map((t) => (
                            <Option value={t} key={t}>
                                {t}
                            </Option>
                        ))}
                    </Select>
                </FormItem>
            </Col>
            {inputsByType}
            <Col style={{ textAlign: "left" }}>
                <Button danger onClick={handleRemove} icon={<DeleteOutlined />} />
            </Col>

            <Col>
                <DrawerLink
                    drawerId={reqSetting}
                    search={{
                        [`${reqSetting}-methodIndex`]: methodIndex.toString(),
                        [`${reqSetting}-responseHandlerIndex`]: responseHandlerIndex.toString(),
                        [`${reqSetting}-id`]: name.toString(),
                    }}
                    action="show"
                >
                    <Button icon={<SettingOutlined />} />
                </DrawerLink>
            </Col>
        </Row>
    );
};
